import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findNationalities = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/nationality${query}`, { headers });
};

export const findNationalityById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/nationality/${id}`, { headers });
};
